<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
import LayoutAdmin from './layouts/LayoutAdmin.vue';
import LayoutPage from './layouts/LayoutPage.vue';

export default {
  name: 'app',
  data() {
    return {
      layouts : {
        default : LayoutPage,
        admin : LayoutAdmin
      }
    }
  },
  computed: {
    layout() {
      const layoutName = this.$route.meta.layout || 'default'
      return this.layouts[layoutName]
    }
  }
}
</script>
<style lang="scss">

$primary-color: #D65931 !default;
$secondary-color: #3887C1;
$other-color: #FCE5CB;

$global-radius: 4px !default;

.button,
button,
input [type="submit"],
input [type="reset"],
input [type="button"] {
  display: inline-block;
  height: 38px;
  padding: 0 30px;
  color: $primary-color;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: .1rem;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border-radius: $global-radius;
  background-color: $other-color;

  cursor: pointer;
  box-sizing: border-box;

  -webkit-transition: color 0;
  transition: color 0;

  -webkit-transition: background-color 0.1s;
  transition: background-color 0.1s;

  &:visited {
    color: $primary-color;
  }

  &:hover, &:visited:hover {
    color: white;
    // border-color: $primary-color;
    background-color: $primary-color;
    text-decoration: none;
    outline: 0;
  }

  &:focus {
    color: white;
    outline: 0;
  }

  &.button-primary {
    color: #fff;
    background-color: $primary-color;
    // border-color: $primary-color;

    &:hover, &:visited:hover {
      color: $primary-color;
      border: $other-color;
      background-color: $other-color;
    }
  }

  &.button-secondary {
    color: #fff;
    background-color: $secondary-color;
    border-color: $secondary-color;
  }
}

</style>
